import {Page} from "./Page";

export default class SoftwarePreamblePage extends Page {
    getNavTitle(): string {
        return 'System Software Evaluation';
    }
}
